// src/lib/writeSandboxHtml.ts
export function writeSandboxHtml(sessionId: string, html: string) {
  if (typeof window === "undefined") return;

  const key = `dayone:sandbox:html:${sessionId}`;

  try {
    window.localStorage.setItem(key, html);

    // Broadcast to parent/other tabs/iframe listeners
    try {
      const bc = new BroadcastChannel("dayone_sandbox");
      bc.postMessage({
        type: "DAYONE_SANDBOX_UPDATED",
        sessionId,
        key,
        len: html?.length ?? 0,
      });
      bc.close();
    } catch {
      // ignore
    }

    // Also dispatch an in-tab event (works even when storage event won’t fire)
    window.dispatchEvent(
      new CustomEvent("DAYONE_SANDBOX_UPDATED", {
        detail: { sessionId, key, len: html?.length ?? 0 },
      })
    );

    // Hard debug (safe)
    (window as any).__lastSandboxWrite = {
      sessionId,
      key,
      len: html?.length ?? 0,
      at: new Date().toISOString(),
      preview: String(html || "").slice(0, 500),
    };

    // eslint-disable-next-line no-console
    console.log("[writeSandboxHtml] wrote", key, "len=", html?.length ?? 0);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("[writeSandboxHtml] FAILED", key, err);
  }
}
